import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'mom-form-field-number',
  templateUrl: './form-field-number.component.html',
  styleUrls: ['./form-field-number.component.scss']
})
export class FormFieldNumberComponent {
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() min: number;
  @Input() max: number;
  @Input() required: boolean;
  @Input() helper: string;

  @Output() keyupEnter = new EventEmitter<void>();
}
